import React from "react";
import moment from "moment";
import { actionLabel, statusClass } from "./userAuditConstants";
import "../applications/auditTrail/AuditTrailModal.css";

const formatJson = (value) => {
  if (value == null) return null;
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
};

/** Shared timeline list for global page and per-user History modal. */
const UserAuditEntryList = ({ logs, loading, error, onOpenHistory }) => {
  if (loading) {
    return <div className="audit-modal-loading">Loading audit trail…</div>;
  }
  if (error) {
    return <div className="audit-modal-error">{error}</div>;
  }
  if (!logs?.length) {
    return <div className="audit-modal-empty">No audit entries found.</div>;
  }

  return (
    <ul className="audit-timeline">
      {logs.map((log) => (
        <li key={log.id} className="audit-timeline-item">
          <div className="audit-timeline-title-row">
            <p className="audit-timeline-desc">
              {log.description || "—"}
            </p>
            <div className="audit-timeline-badge">
              {actionLabel(log.action)}
            </div>
          </div>
          <div className="audit-timeline-main">
            <div className="audit-timeline-meta">
              <span className="audit-timeline-actor d-flex flex-row align-items-center gap-2">
                <span>
                  {log.actor_name ||
                    (log.actor_type === "SYSTEM"
                      ? "System"
                      : log.actor_type === "ANONYMOUS"
                        ? "Anonymous"
                        : "Unknown")}
                  {log.actor_role ? ` (${log.actor_role})` : ""}
                </span>
                {log.actor_email ? (
                  <span className="audit-timeline-email">{log.actor_email}</span>
                ) : null}
              </span>
              <span
                className={`reasonText boardButton ${statusClass(log.status)}`}
                style={{ fontSize: 11, padding: "2px 8px" }}
              >
                {log.status || "—"}
              </span>
              <span>
                {log.occurred_at
                  ? moment(log.occurred_at).format("YYYY-MM-DD HH:mm")
                  : "—"}
              </span>
            </div>
            {(log.target_name || log.target_email || log.target_user_id) && (
              <p className="audit-timeline-states">
                Target:{" "}
                {onOpenHistory && log.target_user_id ? (
                  <button
                    type="button"
                    className="btn btn-link btn-sm p-0 align-baseline"
                    onClick={() =>
                      onOpenHistory({
                        id: log.target_user_id,
                        label:
                          log.target_name ||
                          log.target_email ||
                          `User #${log.target_user_id}`,
                      })
                    }
                  >
                    {log.target_name || log.target_email || `#${log.target_user_id}`}
                  </button>
                ) : (
                  log.target_name || log.target_email || "—"
                )}
                {log.target_email && log.target_name
                  ? ` · ${log.target_email}`
                  : ""}
                {log.target_role ? ` · ${log.target_role}` : ""}
              </p>
            )}
            {log.failure_reason ? (
              <p className="audit-timeline-remarks">
                Failure: {log.failure_reason}
              </p>
            ) : null}
            {log.reason ? (
              <p className="audit-timeline-remarks">Reason: {log.reason}</p>
            ) : null}
            {log.changed_fields?.length ? (
              <p className="audit-timeline-states">
                Changed: {log.changed_fields.join(", ")}
              </p>
            ) : null}
            {/* {(log.old_values || log.new_values) && (
              <pre
                style={{
                  margin: "6px 0 0",
                  fontSize: 11,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  background: "#f6f8fb",
                  padding: 8,
                  borderRadius: 4,
                }}
              >
                {log.old_values
                  ? `Old: ${formatJson(log.old_values)}\n`
                  : ""}
                {log.new_values ? `New: ${formatJson(log.new_values)}` : ""}
              </pre>
            )} */}
          </div>
        </li>
      ))}
    </ul>
  );
};

export default UserAuditEntryList;
